import { Avatar } from 'antd';
import classNames from 'classnames';

import { EvenTooltip } from '../../_atomics/ToolTips/EvenTooltip';

import './UserAvatar.scss';

export interface UserAvatarProps {
  avatarUrl?: string;
  className?: string;
  name?: string;
  size?: number | 'small' | 'default' | 'large';
  withTooltip?: boolean;
}

export const generateColor = (str: string) => {
  const strArray = str.split('');

  const colorHash = strArray?.reduce(
    (acc, currChar) => currChar.charCodeAt(0) + ((acc << 5) - acc),
    0
  );

  return `hsl(${colorHash % 360}, 50%, 60%)`;
};

export const getInitials = (name: string) => {
  const formattedNameValue = name.replace(/\s+/g, ' ').trim();
  const splitName = formattedNameValue.toUpperCase().split(' ');

  if (splitName.length <= 1) {
    return splitName[0][0] || '';
  }

  return `${splitName[0][0]}${splitName[splitName.length - 1][0]}`;
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  avatarUrl,
  className,
  name,
  size,
  withTooltip,
}) => {
  if (!name) {
    return null;
  }

  return (
    <figure className={classNames('user-avatar', className)}>
      {withTooltip && name ? (
        <EvenTooltip text={name}>
          <Avatar
            className="avatar"
            size={size}
            src={avatarUrl}
            style={{ backgroundColor: generateColor(name || '') }}
          >
            {getInitials(name || '')}
          </Avatar>
        </EvenTooltip>
      ) : (
        <Avatar
          className="avatar"
          size={size}
          src={avatarUrl}
          style={{ backgroundColor: generateColor(name || '') }}
        >
          {getInitials(name || '')}
        </Avatar>
      )}

      {!withTooltip && <figcaption className="name">{name}</figcaption>}
    </figure>
  );
};
